export default "__VITE_ASSET__RSrDtiJ___"